'use strict';

var region;
var firstActionFuntionBradescoSimulacaoResultado = true;
var numeroSimulacao = 0;
var isCpf = true;

var requestAjaxSimulacao = null;
var requestAjaxResumo = null;

var responseFormSingleStep = null;
var leadDataSingleStep = null;

function bradescoPreAprovacao(leadData, userUF) {

  var formSingle = document.querySelector('.form-offer-single-step');
  if (formSingle) {
    window.scrollTo({ behavior: "smooth", top: window.scrollY + formSingle.getBoundingClientRect().top - 200 });
  }

  var formCatalog = document.querySelector('#form-catalog-bradesco');
  if (formCatalog) {
    window.scrollTo({ behavior: "smooth", top: window.scrollY + formCatalog.getBoundingClientRect().top - 200 });
  }

  region = userUF == 'AP' ? 'todos-os-estados' : userUF.toLowerCase();
  bradescoEvents('Clique Simulação Bradesco');
  bradescoPreAprovacaoLoader(leadData);
  $("body").on("click", '.autoline-redirect', function () {
    bradescoEvents('Clique botão Autoline');
  });
  bradescoEvents('Consulta Pré-aprovação');
  $.ajax({
    url: ajaxHandler.api_bradesco + 'consulta_pre_aprovacao',
    type: 'POST',
    data: {
      data: leadData
    },
    beforeSend: function beforeSend() {
      if (leadData && leadData.source && leadData.source != "lp") {
        $("html, body").animate({ scrollTop: 200 }, 700);
      }
    },
    success: function success(response) {
      if (response && response.data.valida_pre_analise.codigoResultadoAnalise == 1) {
        bradescoEvents('Usuário pré-aprovado');
        $('.card-form-body').text('').children('').remove();
        $('.jc-loader-bradesco').remove();
        $('.card-form-body').append(response.data.html);
        sessionStorage.setItem('dataBFF', JSON.stringify(response));
        bradescoSimulacaoConsultar();
        bradescoSliderSetup();
        $('.bradesco-slider-button input').trigger('change');
      } else if (response && response.data.dealershipFail == 1) {
        bradescoDealershipFail(region);
      } else if (response && response.data.valida_pre_analise.codigoResultadoAnalise == 2) {
        bradescoReproval(region);
      } else {
        console.log({ region: region });
        bradescoSimulationError(region);
      }
    },
    error: function error(data) {
      if (data.responseJSON && data.responseJSON.data) {
        if (data.responseJSON.data.dealershipFail && data.responseJSON.data.dealershipFail == 1) {
          bradescoDealershipFail(region);
        } else {
          bradescoSimulationError(region);
        }
      } else {
        bradescoSimulationError(region);
      }
      $('.jc-loader-bradesco').remove();
    }
  });
}

function bradescoSimulacaoConsultar() {

  var preAnalise = JSON.parse(sessionStorage.dataBFF);

  if (preAnalise.data.client.cpfcnpj.replace(/\D/g, '').length > 11) {
    isCpf = false;
  } else {
    isCpf = true;
  }

  var dataSimulacao = {
    anoFabricacao: preAnalise.data.veiculo.ano_fabricacao,
    codigoIndVeiculoZero: preAnalise.data.veiculo.is_0km ? 'S' : 'N',
    codigoMolicar: preAnalise.data.fipe_molicar.codigoMolicar,
    numeroControleCpfCnpj: preAnalise.data.client.cpfcnpj.substr(-2, 2),
    numeroCpfCnpj: preAnalise.data.client.cpfcnpj.replace(/\D/g, '').substr(0, 9),
    numeroFilialCpfCnpj: isCpf ? "0" : "0001",
    numeroPropostaRccp: preAnalise.data.valida_pre_analise.numeroPropostaRccp,
    valorBem: preAnalise.data.veiculo.valorBem,
    valorEntradaSugerida: preAnalise.data.valida_pre_analise.valorEntradaSugerida,
    client: preAnalise.data.client
  };

  sessionStorage.removeItem('dataBFF');

  $('#input-value-form input').change(function (event) {

    dataSimulacao.valorEntrada = $("input[name=inputValue]").val();
    $('#installments').hide().children('').remove();
    $('.installments-value').text('');
    $('.jc-loader-bradesco').show();

    event.preventDefault();

    if (requestAjaxSimulacao) {
      requestAjaxSimulacao.abort();
    }

    if (requestAjaxResumo) {
      requestAjaxResumo.abort();
    }

    requestAjaxSimulacao = $.ajax({
      url: ajaxHandler.api_bradesco + 'simula_pre_financiamento',
      type: 'POST',
      data: {
        params: dataSimulacao
      },
      success: function success(response) {
        if (response.data.details) {
          if (response.data.details.contact_api && response.data.details.contact_api.codigoRetorno == 200) {
            bradescoEvents('Contato cadastrado');
          }
          bradescoEvents('Simulação iniciada');
          bradescoSimulacaoResultado(dataSimulacao.valorEntrada, response.data.details);
        } else {
          bradescoSimulationError(region);
        }
      },
      error: function error(data) {
        if (data && data.statusText == "abort") {
          return;
        }

        bradescoSimulationError(region);
      }
    });
  });
}

function bradescoSimulacaoResultado(valorEntrada, result) {

  valorEntrada = parseFloat(valorEntrada).toFixed(2);
  if (!result.listaSaidaFnprp860Prazo) {
    bradescoSimulationError(region);
  }
  var filteredResult = result.listaSaidaFnprp860Prazo.filter(entradaFilter);
  var parcela, prazo, valorTotal;

  filteredResult.forEach(getInstallmentsValues);
  $('#installments').show();
  $('.jc-loader-bradesco').hide();

  numeroSimulacao = result.numeroSimulacao;

  if (firstActionFuntionBradescoSimulacaoResultado) {
    $("#installments").change(function () {
      var selected = $('#installments').find(":selected");
      parcela = selected.data('valorParcela');
      prazo = selected.data('quantidadePrazo');
      valorTotal = parseFloat(prazo) * parseFloat(parcela) + parseFloat(valorEntrada);
      $(".installments-value").text('R$ ' + parcela.replaceAll('.', ','));
      bradescoResumoCondicoes(selected.data());
    });

    $("#generate-voucher").click(function () {
      if ($('#installments').find(":selected").length == 1) {

        $('#entradaVoucher').text(convertToCurrency(parseFloat(valorEntrada)));
        $('#prazoVoucher').text(prazo + ' meses');
        $('#parcelaVoucher').text(convertToCurrency(parseFloat(parcela)));
        $('#valorTotal').text(convertToCurrency(valorTotal));
        $('#voucher-bradesco').modal('show');
        $('#generate-voucher + .text-danger').hide();
        bradescoEvents('Clique Gerar Voucher');
      } else {
        $('#generate-voucher + .text-danger').fadeIn();
      }
    });
  }

  firstActionFuntionBradescoSimulacaoResultado = false;

  $("#installments").val($("#installments option:first").val());
  $("#installments").trigger('change');

  function entradaFilter(item) {
    if (item.valorEntradaAprovado == valorEntrada) {
      return true;
    }
  }
}

function getInstallmentsValues(element) {
  var option = $('<option></option>').text(element.quantidadePrazo + ' X');
  option.val(element.quantidadePrazo);
  option.data('quantidadePrazo', element.quantidadePrazo);
  option.data('valorParcela', element.listaPrestacao[0].valorParcela);
  option.data('valorCoefAplicado', element.valorCoefAplicado);
  option.data('valorEntradaAprovado', element.valorEntradaAprovado);
  option.data('valorLiquidoAprovado', element.valorLiquidoAprovado);
  $('#installments').append(option);
}

function bradescoSimulationError(region) {
  bradescoEvents('Erro na simulação');
  var autoline_url = 'https://autoline.com.br/comprar/carros/novos/' + region + '/todas-as-cidades/todas-as-marcas/todos-os-modelos/todas-as-versoes/todos-os-anos/todas-as-cores/todos-os-precos?geofilter=undefined';
  var error_html = '<p class="my-3">Não foi possível realizar a sua consulta agora, tente novamente mais tarde. Não deixe de conferir diversas outras ofertas no <a href="' + autoline_url + '" target="_blank">Autoline.com.br</a></p><div class="d-flex justify-content-center"><button type="button" class="autoline-redirect btn btn-bradesco btn-block w-auto"><a target="_blank" href="' + autoline_url + '">Ver ofertas</a></button></div>';
  $('.card-form-body').text('').children('').remove();
  $('.card-form-body').append(error_html);
  $('.jc-loader-bradesco').remove();
}

function bradescoDealershipFail(region) {
  bradescoEvents('Concessionária selecionado sem match');
  var autoline_url = 'https://autoline.com.br/comprar/carros/novos/' + region + '/todas-as-cidades/todas-as-marcas/todos-os-modelos/todas-as-versoes/todos-os-anos/todas-as-cores/todos-os-precos?geofilter=undefined';
  var error_html = '<p class="my-3">Poxa, não conseguimos concluir a simulação. Não deixe de conferir diversas outras ofertas no <a href="' + autoline_url + '" target="_blank">Autoline.com.br</a></p><div class="d-flex justify-content-center"><button type="button" class="autoline-redirect btn btn-bradesco btn-block w-auto"><a target="_blank" href="' + autoline_url + '">Ver ofertas</a></button></div>';
  $('.card-form-body').text('').children('').remove();
  $('.card-form-body').append(error_html);
  $('.jc-loader-bradesco').remove();
}

function bradescoReproval(region) {
  bradescoEvents('Usuário reprovado');
  var autoline_url = 'https://autoline.com.br/comprar/carros/novos/' + region + '/todas-as-cidades/todas-as-marcas/todos-os-modelos/todas-as-versoes/todos-os-anos/todas-as-cores/todos-os-precos?geofilter=undefined';
  var error_html = '<p class="my-3">Poxa, infelizmente não conseguimos concluir a sua solicitação neste momento. Gostaria de ver outras opções e ofertas no <a href="' + autoline_url + '" target="_blank">Autoline.com.br</a></p><div class="d-flex justify-content-center"><button type="button" class="autoline-redirect btn btn-bradesco btn-block w-auto"><a target="_blank" href="' + autoline_url + '">Ver ofertas</a></button></div>';
  $('.card-form-body').text('').children('').remove();
  $('.card-form-body').append(error_html);
  $('.jc-loader-bradesco').remove();
}

function bradescoPreAprovacaoLoader() {
  var leadData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var loader_html = '<h3 id="form-header-text" class="font-weight-bold h3 mt-3 text-primary">Obrigado!</h3><p class="text-muted">Em breve você receberá um contato para conversar sobre as condições comerciais que possibilitem o fechamento do negócio.</p><hr><p class="mb-3">Consultando pré-aprovação do financiamento. Aguarde...</p>';
  if (leadData && leadData.source && leadData.source == "lp") {
    loader_html = '<p class="text-muted">Consultando pré-aprovação do financiamento. Aguarde...</p><hr>';
  }
  $('.card-form-body').text('').children('').remove();
  $('.card-form-body').append(loader_html);
  $('.jc-loader-bradesco').show();
}

function bradescoSliderSetup() {
  var inputSlider = $("input[name=inputValue]");
  var inputText = $("input[name=inputValue2]");

  inputSlider.on('change', function () {
    inputText.val(convertToCurrency(parseInput(inputSlider.val(), 0)));
  });

  inputText.on('change', function () {
    if (formatInput($(this).val()) <= parseInput(inputSlider.attr('min'), 0)) {
      setInputMin();
    } else if (formatInput($(this).val()) >= parseInput(inputSlider.attr('max'), 0)) {
      setInputMax();
    } else {
      inputSlider.val(formatInput(inputText.val()));
      bradescoResumoCondicoes();
      this.value = convertToCurrency(parseInput(inputSlider.val(), 0));
    }
  });

  $('.right-slider').on('click', function () {
    if (formatInput(inputText.val()) + 1000 > parseInput(inputSlider.attr('max'), 0)) {
      setInputMax();
    } else {
      var price = parseInput(inputText.val(), 1000);
      inputSlider.val(price);
      inputText.val(convertToCurrency(price));
    }
    inputSlider.trigger('change');
  });

  $('.left-slider').on('click', function () {
    if (formatInput(inputText.val()) - 1000 < parseInput(inputSlider.attr('min'), 0)) {
      setInputMin();
    } else {
      var price = parseInput(inputText.val(), -1000);
      inputSlider.val(price);
      inputText.val(convertToCurrency(price));
    }
    inputSlider.trigger('change');
  });

  function setInputMax() {
    inputSlider.val(inputSlider.attr('max'));
    inputText.val(convertToCurrency(parseInput(inputSlider.val(), 0)));
  }

  function setInputMin() {
    inputSlider.val(inputSlider.attr('min'));
    inputText.val(convertToCurrency(parseInput(inputSlider.val(), 0)));
  }

  var span = document.querySelector("#numVoucher");

  span.onclick = function () {
    bradescoEvents('Voucher copiado');
    document.execCommand("copy");
  };

  span.addEventListener("copy", function (event) {
    event.preventDefault();
    if (event.clipboardData) {
      event.clipboardData.setData("text/plain", span.textContent);
    }
  });
}

function convertToCurrency(value) {
  return parseFloat(value).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2
  });
}

function parseInput(element, value) {
  return parseFloat(formatInput(element)) + value;
}

function formatInput(value) {
  return value.replace(/[^0-9,]*/g, '').replace(',', '.');
}

function bradescoEvents(action) {
  var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Bradesco - Ofertas 0km',
    'eventAction': action,
    'eventLabel': label
  });
}

$(document).ready(function () {
  var isCatalog = $('#is-catalog-model-bradesco').length != 0;

  if (isCatalog) {
    var bradescoCheckbox = $('input[type=checkbox][name=bradesco-optin]');

    if (bradescoCheckbox) {
      var buttonSubmit = $('#form-catalog-bradesco').find('button[type="submit"]');

      bradescoCheckbox.change(function () {
        if ($(this).is(':checked')) {
          buttonSubmit.removeClass('btn-primary');
          buttonSubmit.addClass('btn-bradesco');
          buttonSubmit.text('Simular financiamento e consultar oferta');
        } else {
          buttonSubmit.removeClass('btn-bradesco');
          buttonSubmit.addClass('btn-primary');
          buttonSubmit.text('Receber ofertas futuras');
        }
      });

      bradescoCheckbox.trigger('change');
    }
  } else {
    $('#ignore-modal-bradesco').click(function () {
      closeModalOfertaBradesco(false);
    });
    $('#button-close-modal-bradesco').click(function () {
      closeModalOfertaBradesco(false);
    });

    $('#check-bradesco').change(function () {
      if ($(this).is(':checked')) {
        $('.check-back-layout').css('background-color', '#FFFFFF');
      } else {
        $('.check-back-layout').css('background-color', 'transparent');
      }
    });

    $('#form-modal-oferta-bradesco').submit(function (e) {
      e.preventDefault();
      closeModalOfertaBradesco(true);
    });
  }
});

function openModalOfertaBradesco(response, leadData) {
  responseFormSingleStep = response;
  leadDataSingleStep = leadData;

  $('.modal-bradesco-oferta').css("display", "flex").hide().fadeIn();
}

function closeModalOfertaBradesco() {
  var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;


  if (status) {
    $('#logo-bradesco-oferta').removeClass('d-none');
    bradescoPreAprovacao(leadDataSingleStep, responseFormSingleStep.data.userUF);
  } else {
    if (responseFormSingleStep && responseFormSingleStep.data) {
      showThankYouMsg(responseFormSingleStep.data);
      bradescoEvents('Lead gerado desmarcando checkbox Bradesco');
    }
  }

  $('.modal-bradesco-oferta').fadeOut(300);
}

function bradescoResumoCondicoes(input) {
  $("#resume span").slideUp();
  $('#generate-voucher').prop('disabled', true);
  requestAjaxResumo = $.ajax({
    url: ajaxHandler.api_bradesco + 'resumo_condicoes',
    type: 'POST',
    data: {
      data: input,
      numeroSimulacao: numeroSimulacao
    },
    success: function success(response) {
      bradescoUpdateResume(response.data);
    },
    error: function error(data) {
      if (data && data.statusText == "abort") {
        return;
      }
    }
  });
}

function bradescoUpdateResume(data) {

  var valorTarifaCadastro_19 = void 0,
      valorTarifaBem_21 = void 0;

  switch (data.valorTarifas) {
    case '1605.00':
      valorTarifaCadastro_19 = 990.00;
      valorTarifaBem_21 = 615.00;
      break;
    case '990.00':
      valorTarifaCadastro_19 = 990.00;
      valorTarifaBem_21 = 0;
      break;
    case '615.00':
      valorTarifaCadastro_19 = 0;
      valorTarifaBem_21 = 615.00;
      break;
    default:
      valorTarifaCadastro_19 = 0;
      valorTarifaBem_21 = 0;
      break;
  }

  var valorTotalParcelas_6 = parseFloat(data.codigoPrestacao) * parseFloat(data.valorParcela),
      valorSolicitado_10 = parseFloat(data.valorBem) - parseFloat(data.valorEntrada),
      valorFinanciado_11 = valorSolicitado_10,
      valorTotalDespesas_15 = parseFloat(data.valorRegistro) + parseFloat(valorTarifaCadastro_19) + parseFloat(valorTarifaBem_21) + parseFloat(data.valorIOFBem),
      valorTotalAtoContrato_12 = valorSolicitado_10 + valorTotalDespesas_15,
      solicitadoCota_14 = valorSolicitado_10 / valorTotalAtoContrato_12,
      totalDespesasCota_16 = valorTotalDespesas_15 / valorTotalAtoContrato_12,
      registroCota_17 = parseFloat(data.valorRegistro) / valorTotalAtoContrato_12,
      tarifaCadastroCota_20 = valorTarifaCadastro_19 / valorTotalAtoContrato_12,
      tarifaBemCota_22 = valorTarifaBem_21 / valorTotalAtoContrato_12,
      iofCota_24 = parseFloat(data.valorIOFBem) / valorTotalAtoContrato_12;

  $('#numVoucher').text(data.numeroSimulacao);
  $(".cetMensal").text(parseFloat(data.cetMensal).toFixed(2).replace('.', ','));
  $("#print-cost-am-voucher").text(parseFloat(data.cetMensal).toFixed(2).replace('.', ',') + "%");
  $(".cetAnual").text(parseFloat(data.cetAnual).toFixed(2).replace('.', ','));
  $("#print-cost-aa-voucher").text(parseFloat(data.cetAnual).toFixed(2).replace('.', ',') + "%");
  $(".quantidadePrazo").text(data.codigoPrestacao);
  $(".valorParcela").text(convertToCurrency(data.valorParcela));
  $(".valorTotalParcelas").text(convertToCurrency(valorTotalParcelas_6));
  $(".valorBem").text(convertToCurrency(data.valorBem));
  $(".valorEntrada").text(convertToCurrency(data.valorEntrada));
  $(".valorSolicitado").text(convertToCurrency(valorSolicitado_10));
  $(".valorFinanciado").text(convertToCurrency(valorFinanciado_11));
  $(".valorTotalAtoContrato").text(convertToCurrency(valorTotalAtoContrato_12));
  $(".valorSolicitadoCota").text(solicitadoCota_14.toFixed(2));
  $(".valorTotalDespesas").text(convertToCurrency(valorTotalDespesas_15));
  $(".valorTotalDespesasCota").text(totalDespesasCota_16.toFixed(2));
  $(".valorRegistro").text(convertToCurrency(data.valorRegistro));
  $(".valorRegistroCota").text(registroCota_17.toFixed(4));
  $(".valorTarifasCadastro").text(convertToCurrency(valorTarifaCadastro_19));
  $(".valorTarifasCadastroCota").text(tarifaCadastroCota_20.toFixed(4));
  $(".valorTarifasBem").text(convertToCurrency(valorTarifaBem_21));
  $(".valorTarifasBemCota").text(tarifaBemCota_22.toFixed(4));
  $(".valorIOF").text(convertToCurrency(data.valorIOFBem));
  $(".valorIOFCota").text(iofCota_24.toFixed(2));

  $("#resume span").slideDown();
  $('#generate-voucher').prop('disabled', false);
}